var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6249 3.33331C10.6249 2.98813 10.3451 2.70831 9.99992 2.70831C9.65474 2.70831 9.37492 2.98814 9.37492 3.33331L9.37492 9.37498H3.33325C2.98807 9.37498 2.70825 9.6548 2.70825 9.99998C2.70825 10.3452 2.98807 10.625 3.33325 10.625H9.37492V16.6666C9.37492 17.0118 9.65474 17.2916 9.99992 17.2916C10.3451 17.2916 10.6249 17.0118 10.6249 16.6666V10.625H16.6666C17.0118 10.625 17.2916 10.3452 17.2916 9.99998C17.2916 9.6548 17.0118 9.37498 16.6666 9.37498H10.6249L10.6249 3.33331Z",
    fill: "#ACB9C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.2a33c3d32ffcb0b956c477692bfee0e7.svg";
export { ForwardRef as ReactComponent };